import { Loader } from '@googlemaps/js-api-loader';

class GoogleMap extends HTMLElement {
    constructor() {
        super();

        const mapLat = parseFloat(this.dataset.mapLat);
        const mapLong = parseFloat(this.dataset.mapLong);

        const googleMapsLoader = new Loader({
            apiKey: null,
            version: "weekly"
        });

        googleMapsLoader
            .load()
            .then((google) => {
                const googleMap = new google.maps.Map(this, {
                    center: {
                        lat: mapLat,
                        lng: mapLong
                    },
                    zoom: 14,
                });

                new google.maps.Marker({
                    position: {
                        lat: mapLat,
                        lng: mapLong
                    },
                    map: googleMap
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export {
    GoogleMap
}
